module.exports = __webpack_public_path__ + "static/wallst-496ea5d7bd0f40915b9efe5c2047b841.jpg";